import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import Footer from "../../components/Footer";
import Press from "../../components/Press";
import DropdownMenu from "../../components/DropdownMenu";
import SEO from "../../context/SEO";
import styles from "./style.module.scss";
import banner2 from "../../assets/news/banner/newsBanner2.avif";
import PressBanner from "../../assets/news/PressBanner.avif";
import Boxes from "../../assets/news/boxes.avif";
import SingleBox from "../../assets/news/singleBox.avif";
import Placemat from "../../assets/news/tableScene.jpg";
import Placemats from "../../assets/news/placemats.avif";
import Pen from "../../assets/news/pen.avif";
import PlatePlacemat from "../../assets/news/plate-placemat.avif";
import stackedTrays from "../../assets/home/stackedTrays.avif";
import Orbs from "../../assets/news/terracottaOrbs.avif";
import OrbS1 from "../../assets/home/OrbS1.avif";
import OrbS2 from "../../assets/home/OrbS2.avif";
import OrbS3 from "../../assets/home/OrbS3.avif";
import OrbS4 from "../../assets/home/OrbS4.avif";


import newShopBG85 from "../../assets/videos/shopBackgroundCorrected.mp4";

import shopNightAngled from "../../assets/news/shopNightAngled.avif";



function News() {
  const [showElements, setShowElements] = useState("full-opacity"); // Start visible
  const [vh, setVh] = useState(window.innerHeight * 0.01);

  const prevScrollPos = useRef(window.scrollY); // Critical: useRef for accurate direction

  // Update vh on resize (mobile rotation, etc.)
  useEffect(() => {
    const updateVh = () => setVh(window.innerHeight * 0.01);
    updateVh();
    window.addEventListener("resize", updateVh);
    return () => window.removeEventListener("resize", updateVh);
  }, []);

  // MAIN SCROLL HANDLER — Identical to AllProducts & others
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollPos = window.scrollY;
      const scrollingUp = currentScrollPos < prevScrollPos.current;
      const scrollingDown = currentScrollPos > prevScrollPos.current;
      const atTop = currentScrollPos < 10 * vh;

      if (atTop) {
        setShowElements("full-opacity");      // ← Smooth at top, no animation
      } else if (scrollingUp) {
        setShowElements("fade-in-up");        // Show when scrolling up
      } else if (scrollingDown) {
        setShowElements("fade-out-up");       // Hide when scrolling down
      }

      // Update ref immediately
      prevScrollPos.current = currentScrollPos;
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [vh]);

  return (
    <div>
      <SEO title="Cork Matters - News" />
      <DropdownMenu
        theme="dark-theme"
        showElements={showElements}
        iconColour="white"
      />
      <div className={styles.banner}>
        <img src={banner2} alt="New shopfront" />
        <div className={styles.bannerText}>
          <h1>News</h1>
        </div>
      </div>
      <div className={styles.newsSection}>
        <div className={styles.grid}>
          <div className={styles.textSection}>
            <div className={styles.title}>New Cork Matters® store </div>
            <div className={styles.bottomContent}>
              <div className={styles.mainText}>
                After two years of existence, Cork Matters has opened its new
                store in the center of Porto, at Rua do Rosário 143 -145, in a
                block surrounded by art galleries, alternative and vintage
                stores, design studios, (Bombarda Quarteirão Criativo). A
                Concept Design Store with a selection of products from the
                collection and limited edition series.
              </div>
              {/* <Link className={styles.logoLink}>
                <img src={BombardaLogo} />
              </Link> */}
            </div>
          </div>
          <div className={styles.image}>
            <img src={shopNightAngled} />
          </div>
        </div>
      </div>
      <div className={styles.banner}>
        <img src={PressBanner} alt="Press Page Banner" />
        <div className={styles.bannerText}>
          <h1 className={styles.white}>Press</h1>
        </div>
      </div>
      <Press />
      {/* <div className={styles.bannerNews}>
        <img src={BannerPlaceholder} alt="Attic Family Banner" />
      </div> */}
      <div className={styles.grid}>
        <div className={`${styles.squarePhoto} ${styles.span6}`}>
          <img src={Orbs} />
        </div>
        <div className={styles.squarePhotoSubgrid}>
          <div className={`${styles.squarePhoto} ${styles.span3} ${styles.span2Mobile}`}>
            <img src={OrbS1} />
          </div>
          <div className={`${styles.squarePhoto} ${styles.span3} ${styles.span2Mobile}`}>
            <img src={OrbS2} />
          </div>
          <div className={`${styles.squarePhoto} ${styles.span3} ${styles.span2Mobile}`}>
            <img src={OrbS3} />
          </div>
          <div className={`${styles.squarePhoto} ${styles.span3} ${styles.span2Mobile}`}>
            <img src={OrbS4} />
          </div>
        </div>
      </div>
 
        <div className={styles.grid}>
          <div className={`${styles.landscapePhoto} ${styles.span12} ${styles.paddingTopBottom16}`}>
            <video src={newShopBG85} autoPlay loop muted playsInline />
          </div>
        </div>

      <div className={styles.newsSection}>
        <div className={styles.grid}>
          <div className={`${styles.textSection} ${styles.noMobileReorder}`}>
            <div className={styles.title}>Colour and cork</div>
            <div className={styles.bottomContent}>
              <div className={styles.mainText}>
                Cork is a versatile and sustainable material that is
                increasingly being used in interior design and decorative
                objects. Adding color to these cork objects further expands the
                creative and aesthetic possibilities, allowing the final object
                to become more contemporary. Lamps and lampshades made from
                colored cork offer soft, diffused lighting, ideal for creating a
                welcoming atmosphere. Colors can vary to suit the style of the
                room, from pastel shades to vibrant colors.
              </div>
              <div className={styles.linkContainer}>
                <Link
                  to="/shop#lighting"
                  className={`${styles.isAlt} ${styles.underlineLink}`}
                >
                  See the Orb Lighting Collection
                </Link>
              </div>
            </div>
          </div>
          <div className={styles.image}>
            <img src={stackedTrays} />
          </div>
        </div>
      </div>
      <div className={styles.banner}>
        <img src={Boxes} alt="Press Page Banner" />
      </div>
      <div className={styles.newsSection}>
        <div className={styles.grid}>
          <div className={styles.imageLeft}>
            <img src={SingleBox} />
          </div>
          <div className={styles.textSectionRight}>
            <div className={styles.topContent}>
              <div className={styles.mainText}>
                Cork is a natural material of great importance in our modern
                world. Its sustainability, renewability and recyclability make
                it an environmentally friendly choice. Its insulation
                properties, versatility and health benefits also increase its
                value in various industries. By recognizing the importance of
                cork and choosing cork-based products, we can contribute to a
                more sustainable and environmentally friendly future, while
                enjoying the countless benefits this remarkable material has to
                offer.
              </div>
              <div className={styles.linkContainer}>
                <Link
                  to="/products/all#lighting"
                  className={`${styles.isAlt} ${styles.underlineLink}`}
                >
                  Visit the Shop
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.banner}>
        <img src={Placemat} alt="Press Page Banner" />
      </div>
      <div className={styles.marginTop}></div>
      <div className={styles.pictureSection}>
        <div className={styles.grid}>
          <div className={styles.imageLeft}>
            <img src={Placemats} />
          </div>
          <div className={styles.textSectionRight}>
            <div className={styles.title}>
              Cork as a utilitarian element in the home
            </div>
            <div className={styles.bottomContent}>
              <div className={styles.mainText}>
                Incorporating cork objects on the table not only enhances the
                beauty and elegance of the environment, but also promotes
                sustainable practices. Whether for special occasions or everyday
                use, cork objects offer a perfect combination of functionality,
                style and respect for the environment.
              </div>
              <div className={styles.linkContainer}>
                <Link
                  to="/products/all#tableware"
                  className={`${styles.isAlt} ${styles.underlineLink}`}
                >
                  See the Tableware Collection
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.pictureSection}>
        <div className={styles.grid}>
          <div className={styles.imageLeft}>
            <img src={Pen} />
          </div>
          <div className={styles.image}>
            <img src={PlatePlacemat} />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default News;
